import { render } from "./container-list-v-default.vue?vue&type=template&id=c19d7ccc&scoped=true"
import script from "./container-list-v-default.vue?vue&type=script&lang=js"
export * from "./container-list-v-default.vue?vue&type=script&lang=js"

import "./container-list-v-default.vue?vue&type=style&index=0&id=c19d7ccc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c19d7ccc"]])

export default __exports__